(function ($) {
    'use strict';

    var SELECTOR = '[data-switch-lang]';

    var $body = $('body');

    var SwitchLang = {};

    SwitchLang.onClickSwitchLang = function (event) {
        var $element = $(this),
          href = $element.attr('href');

        if (href.indexOf('#') === -1 && window.location.hash) {
            href += window.location.hash;

            $element.attr('href', href);
        }
    };

    $(document).ready(function () {
        $body.on('click.switch-lang', SELECTOR, SwitchLang.onClickSwitchLang);
    });

})(require('jquery'));
